export function completeNum (num, length) {
  return (Array(length).join('0') + num).slice(-length)
}

export function formatDate (value) {
  let year = value.getFullYear()
  let month = value.getMonth() + 1
  let day = value.getDate()
  month = completeNum(month, 2)
  day = completeNum(day, 2)
  let date = year + '-' + month + '-' + day
  return date
}

export function todayDate () {
  let date = formatDate(new Date())
  return new Date(date)
}

export function WeekDayFormat (value) {
  const weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  let month = value.getMonth() + 1
  let day = value.getDate()
  let week = value.getDay()
  month = completeNum(month, 2)
  day = completeNum(day, 2)
  let date = month + '.' + day + weekMap[week]
  return date
}

export function getRedirect () {
  return sessionStorage.getItem('redirect_url')
}

export function setRedirect (redirectUrl) {
  return sessionStorage.setItem('redirect_url', redirectUrl)
}

export function isWeixin () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i)
}

export function isIos () {
  return window.__wxjs_is_wkwebview
}

export function strLength (text) {
  let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
  let mat = text.match(cnReg)
  if (mat) {
    return mat.length + (text.length - mat.length)
  }
  return text.length
}

export function weekDay (date) {
  let day = date.getDay()
  let text = ''
  switch (day) {
    case 0:
      text = '星期日'
      break
    case 1:
      text = '星期一'
      break
    case 2:
      text = '星期二'
      break
    case 3:
      text = '星期三'
      break
    case 4:
      text = '星期四'
      break
    case 5:
      text = '星期五'
      break
    case 6:
      text = '星期六'
      break
  }
  return text
}

export function getNextMon () {
  let date = new Date()
  let day = date.getDay() || 7
  let leave = 7 - day + 1

  date.setDate(date.getDate() + leave)
  return formatDate(date)
}

export function formatCountDown (time) {
  let day = Math.floor(time / 86400)
  let hour = Math.floor((time - day * 86400) / 3600)
  let minute = Math.floor((time - day * 86400 - hour * 3600) / 60)
  let second = time - day * 86400 - hour * 3600 - minute * 60
  return {
    day: day.toString(),
    hour: hour.toString(),
    minute: completeNum(minute, 2),
    second: completeNum(second, 2)
  }
}

export function getNextMonList (len) {
  len = len || 4
  if (len < 1) len = 1

  let date = new Date()
  let day = date.getDay() || 7
  date.setDate(date.getDate() - day + 1)
  // date.setDate(date.getDate() - 7)

  let data = []
  for (let index = 0; index < len; index++) {
    date.setDate(date.getDate() + 7)
    data.push(formatDate(date))
  }
  return data
}

export function getWeekDay (dateOfCurr) {
  dateOfCurr = dateOfCurr || new Date()
  const timestampOfCurr = dateOfCurr.getTime()
  const dayOfCurr = (dateOfCurr.getDay() + 7 - 1) % 7
  const daysOfWeek = Array.from(new Array(7)).map((_, i) => {
    const date = new Date(timestampOfCurr + (i - dayOfCurr) * 1000 * 60 * 60 * 24)
    return date
  })
  return daysOfWeek
}

export function getCycleWeekDay (start, weekNum) {
  const startDate = new Date(start)

  let weekList = []
  for (let index = 0; index < weekNum; index++) {
    let daysOfWeek = getWeekDay(startDate)
    weekList.push(daysOfWeek)
    startDate.setDate(startDate.getDate() + 7)
  }
  return weekList
}

export function getCycleWeekRange (start, weekNum) {
  const today = todayDate()
  const startDate = new Date(start)
  const endDate = new Date(start)
  endDate.setDate(endDate.getDate() + 6)

  let weekList = []
  for (let index = 0; index < weekNum; index++) {
    let item = {}
    item.start = formatDate(startDate)
    item.end = formatDate(endDate)
    item.current = false
    if (today >= startDate && today <= endDate) {
      item.current = true
    }
    weekList.push(item)
    startDate.setDate(startDate.getDate() + 7)
    endDate.setDate(endDate.getDate() + 7)
  }
  return weekList
}

export function padding (value, width) {
  if (value.length === width) {
    return value
  }

  if (value.length > width) {
    return value.substr(0, width)
  }

  let str = ''

  for (let i = 0; i < width - value.length; i++) {
    str += '0'
  }

  return `${str}${value}`
}

/**
 * 转换回车换行为br标签
 * @param name
 * @returns {*}
 */
export function wrapToBr(name) {
  let string = name;
  try {
      string = string.replace(/\r\n/g, "<br>")
      string = string.replace(/\n/g, "<br>");
      string = string.replace(/\r/g, "<br>");
  } catch (e) {
      console.log(e.message);
  }
  return string;
}
